import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { InfoBox } from './InfoBox';
import { GeneralDetails } from './GeneralDetails';
import { ActionConditions } from './ActionCondiions';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { BonusModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/BonusModel';
import { BonusWinningsModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/BonusWinningsModel';
import { PromoCodes } from './PromoCodes';
import { RewardCondition } from './RewardCondition';
import { Alert } from 'src/domains/common/components/alert/alert';

interface PromotionDetailsPropsType {
    bonusModel: BonusModel | BonusWinningsModel | null;
    userId: number;
}

export const PromotionDetails = observer('PromotionDetails', (props: PromotionDetailsPropsType) => {
    if (props.bonusModel === null) {
        return null;
    }

    const campaignModel = props.bonusModel.campaignModel;
    const campaignModelReady = props.bonusModel.campaignModelWhenReady;
    const bonusId = props.bonusModel.id;
    if (campaignModel === 'loading') {
        return (
            <LoadingV2
                dataTest=''
                title='Loading campaign details...'
            />
        );
    }

    if (campaignModel?.status === 'error') {
        return (
            <Alert
                title='Error Occured'
                variant='destructive'
                icon='shield'
            >
                We cannot retrieve the data. Please try again.
            </Alert>
        );
    }

    if (campaignModelReady === null) {
        return null;
    }

    return (
        <section className='rounded-lg gap-2 flex flex-col bg-muted p-2'>
            <GeneralDetails campaignModel={campaignModelReady} />
            <ActionConditions campaignModel={campaignModelReady} />
            <RewardCondition
                userId={props.userId}
                campaignModel={campaignModelReady}
                bonusId={bonusId}
            />
            <PromoCodes campaignModel={campaignModelReady} />
            <InfoBox>Promotion details</InfoBox>
        </section>
    );
});
